// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vant from 'vant'
import 'vant/lib/index.css'
import http from '@/utils/request'
import './utils/rem'
import store from './utils/store'
import { Lazyload } from 'vant'

Vue.prototype.http = http
Vue.use(http.plugin)
// Vue.prototype.$axios = axios

Vue.config.productionTip = false

Vue.use(Vant)

Vue.use(Lazyload, {
  preLoad: 1.3,
  loading: require('../src/assets/loading.gif'),
  error: require('../src/assets/error.png')
})

new Vue({
    el: '#app',
    router,
    store,
    http: http.plugin,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js